__turbopack_context__.v({
  "className": "cinzel_669b5a95-module__si3-Ka__className",
});
